// place "generic", model neutral types here
// types of data supported by system and ontologies
export var DataType;
(function (DataType) {
    DataType["DECIMAL"] = "decimal";
    DataType["INTEGER"] = "integer";
    DataType["BOOLEAN"] = "boolean";
    DataType["PERCENT"] = "percent";
    DataType["LENGTH"] = "length";
    DataType["WEIGHT"] = "weight";
    DataType["DURATION"] = "duration";
    DataType["TEXT"] = "text";
    DataType["DATETIME"] = "datetime";
    DataType["DATETIMERANGE"] = "datetimerange";
    DataType["DATE"] = "date";
    DataType["FUZZYDATERANGE"] = "fuzzyDateRange";
    DataType["FUZZYDATE"] = "fuzzyDate";
    DataType["MARKDOWN"] = "markdown";
    DataType["MULTILINETEXT"] = "multilineText";
    DataType["CURRENCY"] = "currency";
    DataType["ONEOF"] = "oneOf";
    DataType["BNODE"] = "bnode";
    DataType["INDIVIDUAL_REFERENCE"] = "reference";
    DataType["ENTRY_REFERENCE"] = "entry-reference";
    DataType["WEBLINK"] = "webLink";
    DataType["NOMENCLATURE40"] = "nomenclature40";
    DataType["EXTERNAL_REFERENCE"] = "external-reference";
    DataType["URL"] = "url";
    DataType["ID"] = "id";
    DataType["CLASS"] = "class";
})(DataType || (DataType = {}));
// object reference types -- client side mainly
export var ReferenceType;
(function (ReferenceType) {
    ReferenceType["ENTRY_TYPE"] = "entry";
    ReferenceType["INDIVIDUAL_TYPE"] = "individual";
    ReferenceType["TAG_TYPE"] = "tag";
    ReferenceType["COLLECTION_TYPE"] = "collection";
    ReferenceType["CLASS_TYPE"] = "class";
})(ReferenceType || (ReferenceType = {}));
export var ReferenceCascadeType;
(function (ReferenceCascadeType) {
    ReferenceCascadeType["HIERARCHICAL"] = "hierarchical";
    ReferenceCascadeType["PROJECTED"] = "projected";
    ReferenceCascadeType["ORDINARY"] = "ordinary";
})(ReferenceCascadeType || (ReferenceCascadeType = {}));
export var OwnerIdType;
(function (OwnerIdType) {
    OwnerIdType["ENTRY"] = "entry";
    OwnerIdType["INDIVIDUAL"] = "individual";
    OwnerIdType["ACCOUNT"] = "account";
    OwnerIdType["USER"] = "user";
    OwnerIdType["COLLECTION"] = "collection";
})(OwnerIdType || (OwnerIdType = {}));
export const ENTRY_TYPE = 'entry';
export const INDIVIDUAL_TYPE = 'individual';
export const TAG_TYPE = 'tag';
export const COLLECTION_TYPE = 'collection';
export const CLASS_TYPE = 'class';
var TypedReferenceKeys;
(function (TypedReferenceKeys) {
    TypedReferenceKeys["@type"] = "@type";
    TypedReferenceKeys["value"] = "value";
})(TypedReferenceKeys || (TypedReferenceKeys = {}));
/**
 * mutation types
 */
export var MutationType;
(function (MutationType) {
    MutationType["INSERT"] = "insert";
    MutationType["DELETE"] = "delete";
    MutationType["UPDATE"] = "update";
})(MutationType || (MutationType = {}));
/**
 * repeating control types
 */
export var RepeatingControl;
(function (RepeatingControl) {
    RepeatingControl["FIRST"] = "first";
    RepeatingControl["LAST"] = "last";
    RepeatingControl["ALL"] = "all";
})(RepeatingControl || (RepeatingControl = {}));
/**
 * sort, collation, ordering types
 */
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
})(SortOrder || (SortOrder = {}));
export var SortCollation;
(function (SortCollation) {
    SortCollation["ALPHA"] = "alpha";
    SortCollation["NUMERIC"] = "numeric";
    SortCollation["ID"] = "id";
    SortCollation["DATE"] = "date";
    SortCollation["SEQUENCE"] = "sequence"; // use http://www.catalogit.me/rdf/ontologies/core/common#sequence annotation
})(SortCollation || (SortCollation = {}));
/**
 *
 */
export var HierarchicalOrdering;
(function (HierarchicalOrdering) {
    HierarchicalOrdering["MOST_SPECIFIC_FIRST"] = "mostSpecificFirst";
    HierarchicalOrdering["LEAST_SPECIFIC_FIRST"] = "leastSpecificFirst";
})(HierarchicalOrdering || (HierarchicalOrdering = {}));
//# sourceMappingURL=index.js.map